/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const komboConnectLinkDataSchema = z.object({
	link: z.string(),
})

export type KomboConnectLinkDataSchema = z.infer<typeof komboConnectLinkDataSchema>
